import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

import { Alert, AlertType } from '../models/alert';

@Injectable()
export class AlertService {
	private subject = new Subject<Alert>();
	private keepAfterRouteChange = false; // se true mantiene il alert dopo il cambio del route

	constructor(private router: Router) 
	{
		router.events.subscribe(event => 
			{
			if (event instanceof NavigationStart) 
			{
				if (this.keepAfterRouteChange) 
				{
					this.keepAfterRouteChange = false;
				} 
				else 
				{
					this.clear();
				}
			}
		});
	}

	getAlert(): Observable<any> 
	{
		return this.subject.asObservable();
	}

	success(message: string, keepAfterRouteChange = false, timeout: number = 3000) 
	{
		this.alert(AlertType.Success, message, keepAfterRouteChange, timeout);
	}

	error(message: string, keepAfterRouteChange = false, timeout: number = 3000) 
	{
		this.alert(AlertType.Error, message, keepAfterRouteChange, timeout);
	}

	info(message: string, keepAfterRouteChange = false, timeout: number = 3000) 
	{
		this.alert(AlertType.Info, message, keepAfterRouteChange, timeout);
	}

	warn(message: string, keepAfterRouteChange = false, timeout: number = 3000) 
	{
		this.alert(AlertType.Warning, message, keepAfterRouteChange, timeout);
	}

	alert(type: AlertType, message: string, keepAfterRouteChange = false, timeout: number = 3000) 
	{
		this.keepAfterRouteChange = keepAfterRouteChange;
		this.subject.next(<Alert>{ type: type, message: message });
		setTimeout(() => { this.clear(); }, timeout);
	}

	clear() 
	{
		this.subject.next();
	}
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/services/alert.service.ts